import React, { useCallback, useEffect, useMemo, useState } from "react";
import toastr from "toastr";

import FormDateTimePicker from "app/Components/_form/FormDatePicker/FormDateTimePicker";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import {
  useContractorPerson,
  useContractorPersonDropdown,
  useEmployee,
  useEmployeeDropdown,
} from "app/_helpers/hooks";
import { createMedical } from "app/_services/ehs/MedicalService";
import { Col, Modal, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { employeeFormLabel, MEDICAL_TYPE_OPTION } from "../Constant";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import { BiFlag } from "react-icons/bi";
import { Validation } from "app/_helpers/validation/Validation";
import { TRAINEE_TYPE_OPTION } from "../../TrainingManagement/CONSTANTS";

export default function AddToBatchModalMedical({ show, onHide, title = "Add Medical" }) {
  const [form, setForm] = useState({
    medicalAssigneeType: "",
    medicalAssigneeId: "",
    medicalTestType: "",
  });

  const [error, setError] = useState({
    medicalAssigneeType: "",
    medicalAssigneeId: "",
    medicalTestType: "",
  });

  const [employees, employeesOption] = useEmployeeDropdown();
  const { push } = useHistory();

  const [contractorPersons, contractorPersonsOption] = useContractorPersonDropdown();

  const traineeOption = useMemo(() => {
    switch (form?.medicalAssigneeType) {
      case "employee":
        return employeesOption?.filter((obj) => obj?.employmentStatus === "active");
      case "contractorPerson":
        return contractorPersonsOption?.filter(
          (obj) => obj?.employmentStatus === "active"
        );

      default:
        return [];
    }
  }, [contractorPersonsOption, employeesOption, form?.medicalAssigneeType]);

  const handleClose = useCallback(() => onHide(false), [onHide]);

  const changeDependentDropdown = useCallback(
    (name, value) => {
      switch (name) {
        case "medicalAssigneeType":
          if (form.medicalAssigneeType !== value)
            return {
              medicalAssigneeId: "",
              fatherName: "",
              dob: "",
              aadharNumber: "",
            };
          break;
        case "medicalAssigneeId":
          const data = (
            form?.medicalAssigneeType === "employee" ? employees : contractorPersons
          ).find((d) => d.id === value);

          if (data)
            return {
              fatherName: data?.fatherName,
              dob: data?.dob,
              aadharNumber: data?.aadharNumber,
            };
          break;
        default:
          break;
      }
    },
    [contractorPersons, employees, form.medicalAssigneeType]
  );

  const onChange = useCallback(
    ({ target: { name, value, type, checked } }) => {
      setForm((prevForm) => {
        const updates = {
          ...prevForm,
          [name]: type === "checkbox" ? checked : value,
        };

        const extraToChange = changeDependentDropdown(name, value);

        return { ...updates, ...extraToChange };
      });
    },
    [changeDependentDropdown]
  );

  const onSubmit = useCallback(
    async (validate = "stay", dontGoBack = false) => {
      const errorObj = Validation(form, [
        {
          field_name: "medicalTestType",
          label: employeeFormLabel["medicalTestType"],
          type: "string",
          isRequired: true,
        },

        {
          field_name: "medicalAssigneeId",
          label: employeeFormLabel["medicalAssigneeId"],
          type: "string",
          isRequired: true,
        },
        {
          field_name: "medicalAssigneeType",
          label: employeeFormLabel["medicalAssigneeType"],
          type: "string",
          isRequired: true,
        },
        {
          field_name: "dueDate",
          label: employeeFormLabel["dueDate"],
          type: "string",
          isRequired: true,
        },
      ]);
      setError(errorObj);

      if (Object.values(errorObj).filter((d) => d !== "").length)
        return toastr.warning("Form inputs missing. Please complete all sections.");

      let formObj = {
        medicalAssigneeId: form?.medicalAssigneeId,
        medicalAtLable: form?.medicalAtLable || "medicalOfficer",
        dueDate: form?.dueDate || "2011-02-02",

        moveMedical: "stay",

        medicalAssigneeType: form?.medicalAssigneeType,
        medicalTestType: form?.medicalTestType,
      };

      const response = await createMedical(formObj);

      if (!response?.status) {
        return toastr.error(response?.message);
      }

      toastr.success(response?.message || "Success.");

      push("/health-safety-and-environment/medical/edit/" + response?.data?.id);
    },
    [form, push]
  );

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col md={4}>
            <FormSelect
              name="medicalTestType"
              value={form.medicalTestType}
              onChange={onChange}
              options={MEDICAL_TYPE_OPTION}
              label={employeeFormLabel["medicalTestType"]}
              error={error?.medicalTestType}
              menuPortalTarget={null}
            ></FormSelect>
          </Col>
          <Col md={4}>
            <FormSelect
              name="medicalAssigneeType"
              value={form.medicalAssigneeType}
              onChange={onChange}
              options={TRAINEE_TYPE_OPTION}
              label={employeeFormLabel["medicalAssigneeType"]}
              error={error?.medicalAssigneeType}
              menuPortalTarget={null}
            ></FormSelect>
          </Col>
          <Col md={4}>
            <FormSelect
              name="medicalAssigneeId"
              value={form.medicalAssigneeId}
              onChange={onChange}
              options={traineeOption}
              label={employeeFormLabel["medicalAssigneeId"]}
              error={error?.medicalAssigneeId}
              menuPortalTarget={null}
            ></FormSelect>
          </Col>
          <Col md={4}>
            <FormDateTimePicker
              value={form.dueDate}
              name="dueDate"
              onChangeDate={onChange}
              // timeFormat={"HH:mm:ss"}
              dateFormat="YYYY-MM-DD"
              label={employeeFormLabel["dueDate"]}
              error={error?.dueDate}
            />
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <FormBtn
          className=""
          backBtnTitle={"Close"}
          backOnClick={handleClose}
          onSubmit={onSubmit}
        />
      </Modal.Footer>
    </Modal>
  );
}
